import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Chatbot from './Chatbot';
import AIBot from './AIBot';
/**
 * ChatbotWidget - Floating button and chat window container
 * Button hides when chat window is open
 */
const ChatbotWidget = () => {
    const [isOpen, setIsOpen] = useState(false);
    const location = useLocation();
    // Don't show chatbot on admin pages
    if (location.pathname.startsWith('/admin')) {
        return null;
    }
    // Close chat when route changes
    useEffect(() => {
        setIsOpen(false);
    }, [location.pathname]);
    return (_jsxs(_Fragment, { children: [!isOpen && (_jsx("button", { onClick: () => setIsOpen(true), className: "fixed bottom-0 right-0 md:bottom-6 md:right-6 z-50 transition-all duration-300 hover:scale-105 active:scale-95 origin-bottom-right scale-[0.6] md:scale-100", "aria-label": "Open AI Assistant", children: _jsx("div", { className: "w-32 h-40 flex items-center justify-center", children: _jsx("div", { className: "transform scale-[0.8] origin-center", children: _jsx(AIBot, {}) }) }) })), _jsx(Chatbot, { isOpen: isOpen, onClose: () => setIsOpen(false) })] }));
};
export default ChatbotWidget;
